module.exports = __webpack_public_path__ + "connectivity.svg?7fe067d1b034b78155034a21ae0f29e8";